var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthEast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C9.71667 19 9.47934 18.904 9.288 18.712C9.096 18.5207 9 18.2834 9 18C9 17.7167 9.096 17.4794 9.288 17.288C9.47934 17.096 9.71667 17 10 17H15.6L4.7 6.10005C4.51667 5.91672 4.425 5.68338 4.425 5.40005C4.425 5.11672 4.51667 4.88338 4.7 4.70005C4.88334 4.51672 5.11667 4.42505 5.4 4.42505C5.68334 4.42505 5.91667 4.51672 6.1 4.70005L17 15.6V10C17 9.71672 17.096 9.47905 17.288 9.28705C17.4793 9.09572 17.7167 9.00005 18 9.00005C18.2833 9.00005 18.5207 9.09572 18.712 9.28705C18.904 9.47905 19 9.71672 19 10V18C19 18.2834 18.904 18.5207 18.712 18.712C18.5207 18.904 18.2833 19 18 19H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthEast);
export default __webpack_public_path__ + "static/media/south-east.795636e9cb956a3a18ef3b8bde49aa39.svg";
export { ForwardRef as ReactComponent };